import { NotifyHelper } from '../../../helpers/toast';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { eYCHTGroupActionTypeIds, IYCHTGroupActionTypes } from '../../action-types/danh-muc/IYCHTGroupActionTypes';
import { IYCHTGroupPageState } from '../../page-state-model/danh-muc/IYCHTPageState';


const initialState: IYCHTGroupPageState = {
	status: ePageBaseStatus.is_not_initialization,
	app_yeu_cau_ho_tro_groups: [],
	app_yeu_cau_ho_tro_group_selected_ids: [],
	app_yeu_cau_ho_tro_group_editing: undefined,
	is_show_delete_confirm: false,
	is_show_detail_modal: false,
};

export const ychtGroupReducer = (state: IYCHTGroupPageState = initialState, action: IYCHTGroupActionTypes): IYCHTGroupPageState => {
	switch (action.type) {
		case eYCHTGroupActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading,
			};
		case eYCHTGroupActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				app_yeu_cau_ho_tro_groups: action.payload,
			};
		case eYCHTGroupActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload);
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				app_yeu_cau_ho_tro_groups: [],
			};
		case eYCHTGroupActionTypeIds.SELECT_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading,
			};
		case eYCHTGroupActionTypeIds.SELECT_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				app_yeu_cau_ho_tro_groups: action.payload,
			};
		case eYCHTGroupActionTypeIds.SELECT_ERROR:
			NotifyHelper.Error(action.payload);
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				app_yeu_cau_ho_tro_groups: [],
			};
		case eYCHTGroupActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				app_yeu_cau_ho_tro_group_editing: action.payload,
			};
		case eYCHTGroupActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				app_yeu_cau_ho_tro_group_editing: undefined,
			};
		case eYCHTGroupActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				app_yeu_cau_ho_tro_group_selected_ids: action.payload,
			};
		case eYCHTGroupActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true,
			};
		case eYCHTGroupActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false,
			};

		case eYCHTGroupActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting,
			};
		case eYCHTGroupActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success('Xoá dữ liệu thành công.');
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
			};
		case eYCHTGroupActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload);
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false,
			};
		case eYCHTGroupActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving,
			};
		case eYCHTGroupActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success('Thay đổi dữ liệu thành công.');
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
			};
		case eYCHTGroupActionTypeIds.SAVE_ERR:
			NotifyHelper.Error(action.payload);
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_detail_modal: false,
			};
		
		default:
			return state;
	}
};
